import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import { useSnackbar } from 'notistack'

import WelcomeHeader from '../../components/organisms/WelcomeHeader'
import './login.css'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import CheckBox from '../../components/atoms/CheckBox'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import loginSchema from './loginSchema'
import { request } from '../../Utils/Request'
import { apiEndPoint } from '../../Utils/Redux/Store/apiEndpoint'
import JwtDecode from 'jwt-decode'
import { useTranslation } from 'react-i18next'
const Login = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const history = useHistory()
    const { search } = useLocation()
    const Location = useLocation()
    const [userInformation, setUserInfomation] = useState({
        userName: '',
        password: '',
        remberMe: false,
    })
    const { t } = useTranslation()

    // const userToken = localStorage.getItem('userToken')
    //     ? JSON.parse(localStorage.getItem('userToken'))
    //     : null
    console.log('login state-', Location.state)
    const userInfo = localStorage.getItem('userInfo')
        ? JSON.parse(localStorage.getItem('userInfo'))
        : null

    const formik = useFormik({
        initialValues: userInformation,
        enableReinitialize: true,
        validationSchema: loginSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    username: values.userName,
                    password: values.password,
                }
                const res = await request('post', apiEndPoint.login, data)
                if (formik.values.remberMe) {
                    localStorage.setItem('userInfo', JSON.stringify(data))
                } else {
                    localStorage.removeItem('userInfo')
                }
                if (res.data.status === 'yes') {
                    localStorage.setItem('coachToken', res.data.data)
                    localStorage.setItem('coachUser', JSON.stringify(JwtDecode(res.data.data)))
                    enqueueSnackbar(res.data.message, { variant: 'success' })
                    if (search) {
                        let params = new URLSearchParams(search)
                        return history.push(params.get('return'))
                    }

                    const decode = JwtDecode(res.data.data)

                    if (decode.role == 4) {
                        return history.push('/dashboard/ambassador/mylots', Location.state)
                    } else if (decode.role == 0) {
                        return history.push('/home', Location.state)
                    } else {
                        return history.push('/', Location.state)
                    }
                } else {
                    enqueueSnackbar(
                        res.data.message === 'Verification link has not been activated yet'
                            ? 'Admin Will Contact You!'
                            : res.data.message,
                        { variant: 'error' },
                    )
                }
            } catch (error) {
                console.log(error)
            }
        },
    })

    useEffect(() => {
        if (userInfo && typeof userInfo !== 'undefined') {
            setUserInfomation({
                userName: userInfo.username,
                password: userInfo.password,
                remberMe: true,
            })
        }
    }, [])

    return (
        <div className="mobile-signup row m-0">
            <div className=" col-lg-6 col-12 login-content-area">
                <div className="signup-area-content">
                    <h2 className="text-left light-white mb-3">{t('first_lets_get')}!</h2>
                    <form onSubmit={formik.handleSubmit}>
                        <CustomInput
                            label={t('email')}
                            type="text"
                            inputClassName="input-login login-user-name"
                            labelClass="login-user-name-label light-white"
                            placeholder={t('first_name_placehoder')}
                            onChange={formik.handleChange}
                            name="userName"
                            value={formik.values.userName}
                            onBlur={formik.handleBlur}
                            helperText={
                                formik.touched.userName && formik.errors.userName
                                    ? formik.errors.userName
                                    : null
                            }
                            error={formik.touched.userName && formik.errors.userName}
                        />
                        <CustomInput
                            label={t('password')}
                            type="password"
                            inputClassName="input-login login-password"
                            labelClass="login-password-label light-white"
                            placeholder="ABC@1234"
                            onChange={formik.handleChange}
                            name="password"
                            value={formik.values.password}
                            helperText={
                                formik.touched.password && formik.errors.password
                                    ? formik.errors.password
                                    : null
                            }
                            error={formik.touched.password && formik.errors.password}
                        />
                        <div className="login-confirm-area mb-4">
                            <div className="login-remember-me">
                                <CheckBox
                                    label={t('remember_me')}
                                    checked={formik.values.remberMe}
                                    name="remberMe"
                                    onclick={formik.handleChange}
                                />
                            </div>
                            <h6 className="frgtpswrd">
                                <Link to="/forgot_password">{t('forgot_password')}?</Link>
                            </h6>
                        </div>
                        <div className="login-butto">
                            <PrimaryButton
                                customClassName="login-confirm-btn"
                                label={t('start_here')}
                                iconRight={<span className="material-icons">arrow_right_alt</span>}
                                type="submit"
                            />
                        </div>
                    </form>
                </div>

                <div className="login-forgetpswrd justify-content-center">
                    <h6 className="haveAnAcc">
                        {t('dont_have_account')}?{' '}
                        <Link to="/registration_step_1">{t('register')}</Link>{' '}
                    </h6>
                </div>
            </div>
            <div className="col-lg-6 col-12 p-0 borderRight">
                <div className="login-car-image">
                    <div className="car-container">
                        <div className="car-image-contents">
                            <h4 className="light-black">{t('information_privacy')}</h4>
                            <p className="light-black">{t('your_informationn_safe')}</p>
                        </div>
                    </div>
                    {/* <div className="car-image-contents bottom2">
                        <h4 className="light-black">{t('quick_easy')}</h4>
                        <p className="light-black">{t('set_your_car')}</p>
                    </div>
                    <div className="car-image-contents bottom3">
                        <h4 className="light-black"> {t('do_you_need')}?</h4>
                        <p className="light-black">
                            {t('call_sms')} <a href="tel:+46 728 552 329">+46 728 552 329&nbsp;</a>
                            {t('via_chat')}
                        </p>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default Login
